// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './EmptyPopupMessage.scss';

const EmptyPopupMessage = ({ image, message, secondary }) => (
    <div className="EmptyPopupMessage">
        <div className="image-container">{image}</div>

        <p className="description">{message}</p>

        <p className="secondary">{secondary}</p>
    </div>
);

EmptyPopupMessage.propTypes = {
    image: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    message: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
    secondary: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
};

export default EmptyPopupMessage;
